<template>
  <span>
    <!-- footer social if there is newsletter -->
    <span  v-if="footerHasNewsletter">
    <!--All But MOBILE-->
    <v-container fluid class="d-none d-sm-flex fill-height pa-0"  >
      <v-container class="py-0">
          <v-row no-gutters class="pa-0 fill-height">
            <v-col cols="12" md="auto">
              <v-sheet class="fill-height pa-0">
                <span class="font-weight-bold py-0 pr-3">{{
                  siteSettings.FooterSocialMediaTitle
                }}</span>
              </v-sheet>
            </v-col>
            <v-col cols="12" md="auto">
              <v-sheet class="fill-height pa-0">
                <span
                  v-for="(SocialIconen, index) in itemsCombined"
                  :key="index"
                >
                <a :href="SocialIconen.SocialLink" target="_blank" class="text-none text-decoration-none footerbar1icon mr-2">
                    <SvgIconPublic :sizeIcon="iconSize" :url="SocialIconen.SocialIcon"/>
                  </a>
                </span>
              </v-sheet>
            </v-col>
          </v-row>
      </v-container>
    </v-container>

    <!--MOBILE-->
    <v-container  fluid class="d-flex d-sm-none fill-height footerbar2 py-0"  >
      <v-container fluid class="fill-height px-0 py-5">
        <v-container class="py-0">
          <v-row class="pa-0 fill-height justify-center">
            <v-col cols="auto" :style="{ height: '55px' }">
              <v-sheet class="fill-height pa-0">
                <span class="font-weight-bold py-0 mr-1">{{
                  siteSettings.FooterSocialMediaTitle
                }}</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="py-0">
          <v-row class="pa-0 fll-height justify-center">
            <v-col cols="auto" :style="{ height: '55px' }">
              <v-sheet class="fill-height pa-0">
                <v-container class="fill-height pa-0">
                  <span
                    v-for="(SocialIconen, index) in itemsCombined"
                    :key="index"
                  >
                <a :href="SocialIconen.SocialLink" target="_blank" class="text-none text-decoration-none footerbar1icon mr-2">
                  <SvgIconPublic :sizeIcon="iconSize" :url="SocialIconen.SocialIcon"/>

                  </a>
                  </span
                ></v-container>
              </v-sheet>
            </v-col>
          </v-row>

        </v-container>

      </v-container>
    </v-container>
    </span>
    <span >
     <!-- footer social only -->
    <span  v-if="!footerHasNewsletter">
    <v-container fluid class="fill-height pa-0">
      <v-container class="py-0">
        <v-container>
          <v-row no-gutters class="pa-0 fill-height justify-center">
            <v-col cols="auto">
              <v-sheet class="fill-height pa-0">
                <span class="font-weight-bold py-0 pr-3">{{
                  siteSettings.FooterSocialMediaTitle
                }}</span>
              </v-sheet>
            </v-col>
            <v-col cols="auto" >
              <v-sheet class="fill-height pa-0">
                <span
                  v-for="(SocialIconen, index) in itemsCombined"
                  :key="index"
                >
                <a :href="SocialIconen.SocialLink" target="_blank" class="text-none text-decoration-none footerbar1icon mr-2">
                  <SvgIconPublic :sizeIcon="iconSize" :url="SocialIconen.SocialIcon"/>
                    <!-- <v-img
                      :width="iconSize"
                      class="footerbar1icon mr-2 mx-1"
                      :src="SocialIconen.SocialIcon"
                    /> -->
                  </a>
                </span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-container>

    </span>
    </span>
  </span>
</template>

<script setup>
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";
import { useSiteSettingsStore } from "../../store/siteSettings";
const { $helpers } = useNuxtApp()
let FooterSocial = [];
const siteSettings = useSiteSettingsStore();
let footerHasNewsletter =
  $helpers.isset(siteSettings["FooterNewsLetterTitle"]) &&
  siteSettings["FooterNewsLetterTitle"] != "";

const itemsCombined = computed(() => {
  var FooterSocial = [];
  if (
    $helpers.isset(siteSettings["FooterIconFacebookUrl"]) &&
    siteSettings["FooterIconFacebookUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconFacebook, //'Facebook',
      SocialLink: siteSettings["FooterIconFacebookUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconLinkedinUrl"]) &&
    siteSettings["FooterIconLinkedinUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconLinkedin,//'LinkedIn',
      SocialLink: siteSettings["FooterIconLinkedinUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconYoutubeUrl"]) &&
    siteSettings["FooterIconYoutubeUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconYoutube,//'Youtube',
      SocialLink: siteSettings["FooterIconYoutubeUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterWhatsapp"]) &&
    siteSettings["FooterWhatsapp"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconWhatsapp,//'Whatsapp',
      SocialLink: 'https://wa.me/'+siteSettings["FooterWhatsapp"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconInstagramUrl"]) &&
    siteSettings["FooterIconInstagramUrl"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconInstagram,//'Insta',
      SocialLink: siteSettings["FooterIconInstagramUrl"],
    });
  }
  if (
    $helpers.isset(siteSettings["FooterIconTiktok"]) &&
    siteSettings["FooterIconTiktok"] != ""
  ) {
    FooterSocial.push({
      SocialIcon: siteSettings.FooterIconTiktok,//'Tik Tok',
      SocialLink: siteSettings["FooterIconTiktokUrl"],
    });
  }
  return FooterSocial;
});

const iconSize = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 24;
    case "sm":
      return 26;
    case "md":
      return 29;
    case "lg":
      return 30;
    case "xl":
      return 40;
    case "xxl":
      return 40;
    default:
      return 24;
  }
});
</script>
